import { useStore } from "@ludens-reklame/rubics-v3-react/store/hooks";
import { ThemeSettings } from "../../types/theme.js";
import { getLinkProps } from "../../client-utils/getLinkProps.js";
import { RichText } from "../../internal-components/rich-text/rich-text.js";
import { logo } from "../../icons/svg.js";

interface Props {}

const Footer: React.FC<Props> = () => {
  const { themeSettings } = useStore<ThemeSettings>();
  const footerMenus = themeSettings.footerMenus || [];
  const footerText = themeSettings.footerText || undefined;

  return (
    <footer className="footer">
      <div className="top">
        <div className="container">
          <div className="hs vs">
            <div className="menus">
              {footerMenus.map((menu, index) => {
                return (
                  <ul key={index} className={`menu menu-${index}`}>
                    {menu.title && (
                      <li>
                        <h3>{menu.title}</h3>
                      </li>
                    )}

                    {(menu.items || []).map((item, itemIndex) => {
                      if (!item.link) return null;

                      return (
                        <li key={itemIndex}>
                          <a {...getLinkProps(item.link)}>{item.link.title}</a>
                        </li>
                      );
                    })}
                  </ul>
                );
              })}
            </div>
            <div className="logo">{logo}</div>
          </div>
        </div>
      </div>

      {footerText && (
        <div className="bottom">
          <div className="container">
            <div className="hs vs">
              <RichText html={footerText} editable path="footerText" />
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
